import WebsiteLogRepositoryInterface from '@/services/WebsiteLog/interfaces';
import { AxiosInstance } from 'axios';

export default class WebsiteLogRepository implements WebsiteLogRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async requestLogs(websiteId: number, type: string, lines: number, userId: string): Promise<void> {
    await this.axios.get(`/logs/${websiteId}/${type}?lines=${lines}`, {
      headers: {
        'x-user-id': userId,
      }
    });
  }
}
